var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"dialog-simple",attrs:{"visible":_vm.visible,"title":"详情","width":"1200px","close-on-click-modal":false,"close-on-press-escape":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"detail-content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }